export default {
  b2cTip: "我想为我的 C 端用户提供更好的身份认证体验",
  b2bTip: "我想为我的 B 端客户提供更好的身份认证体验",
  b2eTip: "我想为企业员工管理身份",
  tenants: "租户数量仅与不同版本关联，与 MAU 无关，MAU 需单独订阅",
  unit: "¥",
  banner: {
    title: "你只需为",
    "title-other": "付费",
    MAU: "活跃用户",
    "common-tip": "在一个月内，在单个用户池中进行身份验证的任何用户。",
    subtitle: "Authing 已帮助上千家企业和开发者构建标准化的用户身份体系",
    "section-one": {
      title: "免费计划",
      button: "免费使用",
      descript: "体验三大业务场景，最多可达 8,000 月活跃用户",
    },
    "section-two": {
      title: "复杂的场景？",
      button: "立即查看",
      descript: "私有化部署方案，为你的企业构建专属 IDaaS 服务",
    },
  },
  other: {
    free: "免费",
    sales: "咨询销售",
  },
  priceList: {
    choose: "选择你的",
    mau: "活跃用户",
    "choose-mau": "选择你的活跃用户：",
    "choose-mauE": "选择你的员工数：",
    "choose-tip":
      "订阅 1 年，即免 2 个月费用。不同于其他厂商，Authing 只对活跃用户",
    MAU: "活跃用户",
    "choose-tip2": "收费。",
    "choose-tip3": "在一个月内，在单个用户池中进行身份验证的任何用户",
    "month-unit": "月",
    months: "个月",
    "year-unit": "年",
    "monthly-payment": "按月支付",
    "annual-payment": "按年支付",
    "app-scene": "选择你的应用场景",
    sale: "惠",
    b2c: {
      develop: {
        title: "基础版",
        function: {
          item1: "无限个社交账号连接",
          item2: "10 个自建应用",
          item3: "5 个自动化工作流",
        },
      },
      developPro: {
        title: "高级版",
        function: {
          item1: "无限个社交账号连接",
          item2: "20 个自建应用",
          item3: "自定义品牌化",
          item4: "自定义数据库",
          item5: "多因素验证 MFA",
        },
      },
      enterprise: {
        title: "企业版",
        function: {
          item1: "定制化身份连接",
          item2: "无限功能用量",
          item3: "99.99% SLA",
          item4: "1 小时内紧急响应",
          item5: "定制化、个性化功能",
          item6: "私有云部署（可加购）",
        },
      },
    },
    b2b: {
      develop: {
        title: "基础版",
        function: {
          item1: "50 个租户",
          item2: "无限个社交账号连接",
          item3: "1 个企业身份连接",
          item4: "10 个自建应用",
        },
      },
      developPro: {
        title: "高级版",
        function: {
          item1: "100 个租户",
          item2: "无限个社交账号连接",
          item3: "3 个企业身份连接",
          item4: "20 个自建应用 & 集成应用",
          item5: "同步中心、身份供给",
          item6: "自定义域名",
        },
      },
      enterprise: {
        title: "企业版",
        function: {
          item1: "定制化身份连接",
          item2: "无限功能用量",
          item3: "99.99% SLA",
          item4: "1 小时内紧急响应",
          item5: "定制化、个性化功能",
          item6: "私有云部署（可加购）",
        },
      },
    },
    b2e: {
      develop: {
        title: "高级版",
        function: {
          item1: "3 个企业身份连接",
          item2: "20 个自建 & 集成应用",
          item3: "跨应用单点登录 SSO",
          item4: "同步中心、身份供给",
          item5: "组织机构、LDAP",
          item6: "自定义域名",
        },
      },
      enterprise: {
        title: "企业版",
        function: {
          item1: "定制化身份连接",
          item2: "无限功能用量",
          item3: "99.99% SLA",
          item4: "1 小时内紧急响应",
          item5: "定制化、个性化功能",
          item6: "私有云部署（可加购）",
        },
      },
    },
  },
  compare: {
    title: "功能比较",
    free: "免费版",
    develop: "基础版",
    "develop-pro": "高级版",
    enterprise: "企业版",
    authentication: {
      title: "认证",
      feature1: {
        title: "外部活跃用户数",
        enterprise: "根据需要",
        des:
          "在某月份内的单个用户池中，任何进行身份验证的任何外部（非员工）用户。",
        b2c: {
          free: "8,000 MAU",
          develop: "多达 10,000 MAU",
          developPro: "多达 10,000 MAU",
        },
        b2b: {
          free: "200 MAU",
          develop: "多达 1,000 MAU",
          developPro: "多达 1,000 MAU",
        },
        b2e: {},
      },
      feature2: {
        title: "内部活跃人员数",
        enterprise: "根据需要",
        des: "通过企业身份进行人员验证、同步的内部员工。",
        b2c: {},
        b2b: {},
        b2e: {
          free: "免费的 10 个员工",
          develop: "多达 100 个员工",
        },
      },
      feature3: {
        title: "社交账号连接",
        enterprise: "无限",
        des:
          "支持主流的社交平台，例如微信、微博和 GitHub，并且可以与 OAuth2 兼容的任何身份提供商一起使用。",
        b2c: {
          free: "",
          develop: "无限",
          developPro: "无限",
        },
        b2b: {
          free: "",
          develop: "无限",
          developPro: "无限",
        },
        b2e: {
          free: "",
          develop: "无限",
        },
      },
      feature4: {
        title: "企业身份连接",
        enterprise: "无限",
        des:
          "Authing 支持以 SAML、钉钉、企业微信、AD/LDAP、企业 OIDC 及 OAuth 2.0 自定义社交账号等身份提供商对企业内部人员进行身份验证和组织同步。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature5: {
        title: "自定义数据库",
        enterprise: "",
        des:
          "默认情况下，用户数据会被存储在 Authing 的数据库，但是如果你想使用现有的数据库，Authing 支持在每次验证时通过在 Authing 的服务器上运行的数据库脚本连接到你已有的数据库。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature6: {
        title: "身份品牌化",
        enterprise: "",
        des:
          "对基于 OAuth2.0 认证协议的应用，Authing 支持配置用户信息授权页面，让你的用户清楚知晓应用将会获取他的哪些个人信息并进行确认，保障用户知情同意权利。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature7: {
        title: "跨应用单点登录 SSO",
        enterprise: "",
        des:
          "为你的客户、合作伙伴和员工提供自由的单点登录，同时保持必要的安全控制。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature8: {
        title: "应用面板",
        enterprise: "",
        des:
          "Authing 应用面板是所有应用的一站式门户。一旦用户登录，他将看到一个定制化的单点登录面板，其中是 IT 分配给他的所有应用。只需在一个面板上轻点应用，即可轻松登录任何企业软件，自动登录，无需重新输入任何账密。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature9: {
        title: "自建应用",
        enterprise: "无限",
        des: "创建移动、Web、IoT 应用并使用 Authing 进行身份验证。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature10: {
        title: "集成应用",
        enterprise: "无限",
        des:
          "Authing 可对你现有的 SaaS 服务（例如销售易、阿里云等）进行单点登录。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature11: {
        title: "身份供给",
        enterprise: "",
        des:
          "在 Authing 管理后台操作该应用的用户增删改查，Authing 会将用户的修改实时同步到此应用。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
    },
    brand: {
      title: "品牌化",
      feature1: {
        title: "自定义登录体验",
        des: "无需任何代码，就可以自定义终端用户的登录体验。",
        enterprise: "",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature2: {
        title: "自定义消息模版",
        enterprise: "",
        des:
          "简单、方便的内置标准邮件模板，包含了欢迎、密码重置和账户验证的邮件流程。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature3: {
        title: "自定义用户协议",
        enterprise: "",
        des:
          "用于用户在注册/登录时了解你的服务条款和隐私条款等内容，用户在注册/登录时需要勾选相应内容。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature4: {
        title: "自定义域名",
        enterprise: "",
        des:
          "开启自定义域名，为你的用户实现更加一致的品牌化体验。配置完成后，你的用户在通过 SSO 登录时将始终使用你配置的域名。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
    },
    automation: {
      title: "自动化",
      feature1: {
        title: "自定义工作流",
        enterprise: "无限",
        des:
          "Authing 工作流为一组运行在云端的用户自定义 JavaScript 代码，可以让开发者扩展、自定义 Authing 功能。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature2: {
        title: "Webhooks",
        enterprise: "无限",
        des: "针对用户、管理员平台使用触发事件中，进行通知推送。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
    },
    identity: {
      title: "身份自动化",
      feature1: {
        title: "触发器",
        enterprise: "无限",
        des: "单用户池内总计的触发器数量，与工作流数量无关。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature2: {
        title: "触发器调用次数",
        enterprise: "无限",
        des: "所有触发器每月被调用的总次数。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature3: {
        title: "工作流事件节点",
        enterprise: "上新期间均可调用",
        des: "包括但不限于用户、组织增删改等事件节点。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature4: {
        title: "数据处理节点",
        enterprise: "上新期间均可调用",
        des:
          "包括但不限于数据过滤、检测、转换、树状结构转换、数据合成、解析循环、传入 Json 数据等数据节点。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature5: {
        title: "流程控制节点",
        enterprise: "上新期间均可调用",
        des: "包括但不限于条件判断、条件分支、循环、终止等流程控制节点。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature6: {
        title: "工作流内置模板",
        enterprise: "无限",
        des: "各类内置的上下游同步模板。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature7: {
        title: "工作流预集成应用",
        enterprise: "无限",
        des: "所有预集成的应用均可作为事件主体进行调用。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature8: {
        title: "可视化画布交互",
        enterprise: "无限",
        des: "可拖拽、可编排的交互形式。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature9: {
        title: "运行日志",
        enterprise: "无限",
        des: "全量事件工作流的运行日志。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature10: {
        title: "API/SDK",
        enterprise: "无限",
        des: "可供调用的 API/SDK。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
    },
    security: {
      title: "安全",
      feature1: {
        title: "登录防暴破",
        des:
          "默认情况下为所有连接启用防暴破保护，保护用户免受有针对性的黑客攻击。",
        enterprise: "",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature2: {
        title: "密码规则与密码轮换",
        enterprise: "",
        des:
          "使密码在受到强力攻击更难以被猜测，以此来提高密码安全性。Authing 支持按规则来指定密码的格式规则和轮换规则。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature3: {
        title: "短信验证码登录",
        enterprise: "包含 12,000 条/月",
        free10: "共计 10 条",
        des:
          "这是一种替代传统的帐号密码登录的方法。Authing 支持通过短信传递的一次性密码进行用户认证。",
        b2c: {
          free: "包含 100 条/月",
          develop: "包含 300 条/月",
          developPro: "包含 1,500 条/月",
        },
        b2b: {
          free: "包含 100 条/月",
          develop: "包含 300 条/月",
          developPro: "包含 1,500 条/月",
        },
        b2e: {
          free: "包含 100 条/月",
          develop: "包含 300 条/月",
        },
      },
      feature4: {
        title: "自定义短信网关",
        enterprise: "",
        des:
          "默认情况下，短信验证码通过 Authing 短信网关服务发送。但是，如果你有一个自定义的短信网关，你也可以修改连接来使用它。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature5: {
        title: "多因素认证功能",
        enterprise: "无限",
        des:
          "使用通过短信、邮件/传递的一次性代码、Microsoft Authenticator 和 Authing 人脸识别等一次性密码应用程序，在用户登陆时提示其他因素。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature6: {
        title: "协作管理员",
        enterprise: "无限",
        des: "邀请其他的成员和开发者一起编辑和配置 Authing。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
    },
    "user-directory": {
      title: "用户目录",
      feature1: {
        title: "用户管理",
        enterprise: "",
        des:
          "Authing 提供简单而快速的用户管理界面，帮助管理员管理全部用户的身份，包括用户创建、配置、密码重置、阻止和删除用户。背后是 Authing 全面而强大的 API 。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature2: {
        title: "用户扩展字段",
        enterprise: "无限",
        des: "向用户元数据中添加自定义的用户扩展属性字段以满足你的定制化需求。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature3: {
        title: "角色、常规资源权限",
        enterprise: "",
        des: "具有创建与管理权限空间、角色的能力，可以管理常规资源权限",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature4: {
        title: "静态用户组",
        enterprise: "",
        des: "手动添加用户，对用户进行分组管理，并可以统一授权。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature5: {
        title: "组织机构",
        enterprise: "",
        des:
          "对于组织机构部门、员工可进行精细化管理，包括：导入组织机构、组织机构的增删改查、添加删除移动节点等。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature6: {
        title: "同步中心",
        enterprise: "",
        des:
          "可针对于上游数据源和下游业务系统，进行组织机构和用户信息的自动化同步。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature7: {
        title: "多租户 Beta",
        enterprise: "根据需要",
        des:
          "租户代表使用你 SaaS 应用的客户，通我们将为你的应用提供租户级别身份认证和授权、终端用户管理、登录页品牌化等功能。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature8: {
        title: "用户目录 LDAP",
        enterprise: "",
        des:
          "LDAP 即「轻量目录访问协议」，英文全称是「Lightweight Directory Access Protocol」。你可以把它理解为一个树形的、用来存储用户和组织信息的数据库，常用于统一身份认证。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature9: {
        title: "角色扩展字段",
        enterprise: "无限",
        des: "向角色元数据中添加自定义的角色扩展属性字段以满足你的定制化需求。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature10: {
        title: "部门扩展字段",
        enterprise: "无限",
        des: "向部门元数据中添加自定义的部门扩展属性字段以满足你的定制化需求。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature11: {
        title: "注册白名单",
        enterprise: "无限",
        des: "开启后只有白名单里的手机号、邮箱和用户名才能进行注册。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature12: {
        title: "数据资源权限 - 资源数",
        enterprise: "10 个,支持加购",
        des: "具有创建与管理数据资源的能力",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature13: {
        title: "数据资源权限 - 各资源节点数",
        enterprise: "1000 个,支持加购",
        des: "具有创建与管理数据资源的能力",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature14: {
        title: "动态用户组",
        enterprise: "",
        des:
          "根据用户的属性是否符合当前设定的规则自动添加或移除成员，实现更灵活的用户管控。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
    },
    "service-support": {
      title: "服务支持",
      feature1: {
        title: "审计日志存储",
        enterprise: "长达 30 天",
        des:
          "更长的日志数据存储时间，可以满足合规性要求，有助于追溯、取证、分析、诊断和解决身份验证的问题。",
        b2c: {
          free: "长达 1 天",
          develop: "长达 3 天",
          developPro: "长达 10 天",
        },
        b2b: {
          free: "长达 1 天",
          develop: "长达 3 天",
          developPro: "长达 10 天",
        },
        b2e: {
          free: "长达 1 天",
          develop: "长达 10 天",
        },
      },
      feature2: {
        title: "服务级别（SLA）",
        enterprise: "",
        des: "Authing 承诺一定级别的终端用户的服务可用性。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature3: {
        title: "客服时间",
        enterprise: "",
        des:
          "客户可以访问专为付费客户开设的微信群支持，并优先与我们的支持工程师进行电话会议。客户的问题将按照下方的响应时间范围内得到回复。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature4: {
        title: "响应时间",
        enterprise: "1 小时内可紧急响应",
        des: "Authing 将根据客户定制版本的对应服务标准，遵守响应时间。",
        b2c: {
          free: "",
          develop: "48 小时内可紧急响应",
          developPro: "24 小时内可紧急响应",
        },
        b2b: {
          free: "",
          develop: "48 小时内可紧急响应",
          developPro: "24 小时内可紧急响应",
        },
        b2e: {
          free: "",
          develop: "24 小时内可紧急响应",
        },
      },
      feature5: {
        title: "社区支持",
        enterprise: "",
        des: "在 Authing 论坛提出问题并获得解答。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature6: {
        title: "定制开发",
        enterprise: "",
        des:
          "提供企业级的支持，包括指定的客户成功经理和指定的开发人员支持工程师团队，进行必要的远程协助和问题排查，确保对接使用顺利。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature7: {
        title: "私有云部署",
        enterprise: "支持加购",
        des:
          "Authing 负责全部交付及系统上线，包含：私有部署、管理过程中的需求调研、系统部署、实施开发、测试连调、生产上线以及项目管理等。",
        b2c: {},
        b2b: {},
        b2e: {},
      },
    },
  },
  question: {
    title: "常见问题",
    "item-one": {
      title: "我该如何选择 Authing 的技术？",
      descript:
        "我该如何选择 Authing 的技术？请根据你的具体情况选择需要使用的技术。 开始之前，我们建议你阅读此文：",
      link: "为什么所有软件都应该使用单点登录来管理用户？",
    },
    "item-two": {
      title: "如何选择认证方式？",
      descript:
        "若你不理解什么是 OAuth、OIDC、SAML、LDAP 等标准协议且应用安全性要求不高，建议使用普通认证； 若你的应用安全性要求较高，无论是否了解标准协议，请使用标准协议认证。",
    },
    "item-three": {
      title: "Authing 是什么？",
      descript:
        "Authing 提供专业的身份认证和授权服务。 我们为开发者和企业提供用以保证应用程序安全所需的认证模块，这让开发人员无需成为安全专家。 你可以将任意平台的应用接入到 Authing（无论是新开发的应用还是老应用都可以），同时你还可以自定义应用程序的登录方式（如：邮箱/密码、短信/验证码、扫码登录等）。 你可以根据你使用的技术，来选择我们的 SDK 或调用相关 API 来接入你的应用。当用户发起授权请求时，Authing 会帮助你认证他们的身份和返回必要的用户信息到你的应用中。",
    },
    "item-four": {
      title: "为什么要使用 Authing？",
      other: "下面是我们整理的 Authing 的部分使用场景：",
      "descript-one":
        "你想开发一个很酷的程序，这时你想添加用户身份认证和授权。你希望你的用户能使用微信、Github 登录，同时你还希望能追踪到用户的注册来源，活动数据，以便你做后续的用户增长。",
      "descript-two":
        "你做了一个 API，同时你希望能使用 OAuth 2.0 协议保证 API 的安全。",
      "descript-three":
        "你做了很多应用程序，你希望这些应用程序的用户数据可以通过单点登录（Single Sign On）的方式互通。",
      "descript-four":
        "你做了一个 JavaScript 前端应用和一个移动端应用，你希望这两个客户端应用都可以安全的访问你的 API。",
      link: "阅读文档",
    },
  },
};
